import { Grid2 as Grid, Typography } from '@mui/material';
import React from 'react';
import CreditCardDetails from './CreditCardDetails';
import { commonStyles } from './commonStyles';

const Payments = () => {
    return (
        <>
            <Grid container sx={commonStyles.container}>
                <Typography variant="h5" sx={commonStyles.title}>
                    Review &amp; Pay
                </Typography>
                <Typography sx={commonStyles.subtitle} style={{ textAlign: 'justify', maxWidth: 560 }}>
                    Alright, let&apos;s do this! Please check your booking details, and make sure you&apos;ve selected
                    the right time, date, and booking options. Then all we need are some card details, and you&apos;re
                    on your way to adventure
                </Typography>
                <CreditCardDetails />
            </Grid>
        </>
    );
};

export default Payments;
